import { PackagesFormValues } from '../types';

const STORAGE_KEY = 'packageWizardLanguageChange';
const MAX_AGE_MS = 60_000;

export type WizardSnapshot = {
  step: string;
  values: PackagesFormValues;
};

type StoredWizardSnapshot = WizardSnapshot & {
  location: string;
  savedAt: number;
};

const currentLocation = () => `${window.location.pathname}${window.location.search}`;

const isStoredWizardSnapshot = (stored: unknown): stored is StoredWizardSnapshot => {
  if (!stored || typeof stored !== 'object') return false;
  const { step, location, savedAt, values } = stored as Partial<StoredWizardSnapshot>;
  return (
    typeof step === 'string' &&
    typeof location === 'string' &&
    typeof savedAt === 'number' &&
    !!values &&
    typeof values === 'object'
  );
};

export const saveWizardSnapshot = (snapshot: WizardSnapshot) => {
  try {
    const stored: StoredWizardSnapshot = {
      ...snapshot,
      location: currentLocation(),
      savedAt: Date.now(),
    };
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(stored));
  } catch {
    return;
  }
};

export const readWizardSnapshot = (): WizardSnapshot | null => {
  if (typeof window === 'undefined') return null;
  try {
    const stored: unknown = JSON.parse(window.sessionStorage.getItem(STORAGE_KEY) ?? 'null');
    if (!isStoredWizardSnapshot(stored)) return null;
    if (stored.location !== currentLocation()) return null;
    if (Date.now() - stored.savedAt > MAX_AGE_MS) return null;
    return { step: stored.step, values: stored.values };
  } catch {
    return null;
  }
};

export const removeWizardSnapshot = () => {
  try {
    window.sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    return;
  }
};
